import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=5897fd4e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=5897fd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897fd4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5897fd4e')) {
      api.createRecord('5897fd4e', component.options)
    } else {
      api.reload('5897fd4e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=5897fd4e&scoped=true&", function () {
      api.rerender('5897fd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j2p9iagVLaCu/JS/comp/SearchFilterTokens.vue"
export default component.exports